/**
 * Page size for affiliate/referral admin lists and affiliate dashboard.
 * For pagination testing: set to 1 or 2 when you have few rows in DB.
 */
export const REFERRAL_LIST_LIMIT = 10;
export const AFFILIATE_LIST_LIMIT = REFERRAL_LIST_LIMIT;
